export default "__VITE_ASSET__Dqu9om1$__"